import { TBidPackageLog, TWorkflowOverrideReason } from "../model";

export type TBidPackageListResult = {
  bid_package_list_func: Array<TBidPackageLog>;
  feature_workflow_instance?: Array<TWorkflowOverrideReason>;
};

// bid_package_list_view carries no early-tender reason, so it is joined in from
// the workflow instance each row already points at. Both the log and its print
// view need it, or the Tendered column disagrees between screen and paper.
export const joinEarlyTenderReason = <T extends TBidPackageListResult>(
  data: T | undefined
): T | undefined => {
  if (!data) return data;

  const reasonByInstanceId = new Map(
    (data.feature_workflow_instance ?? []).map((instance) => [
      instance.id,
      instance.wf_override_reason
    ])
  );
  if (!reasonByInstanceId.size) return data;

  return {
    ...data,
    bid_package_list_func: data.bid_package_list_func.map((row) =>
      reasonByInstanceId.has(row.feature_workflow_instance_id)
        ? {
            ...row,
            wf_override_reason: reasonByInstanceId.get(
              row.feature_workflow_instance_id
            )
          }
        : row
    )
  };
};
